import {push} from 'react-router-redux';

import api from 'utils/api';
import {USER_LANG} from 'utils/locale';
import {refreshProducts} from 'ducks/products';

// Actions
const SET_LOADING = 'WORK_LOGS/SET_LOADING';
const SET_ERROR = 'WORK_LOGS/SET_ERROR';
const SET_WORK_LOGS = 'WORK_LOGS/SET_WORK_LOGS';
const PREPEND_WORK_LOG = 'WORK_LOGS/PREPEND_WORK_LOG';
const UPDATE_WORK_LOG = 'WORK_LOGS/UPDATE_WORK_LOG';
const REMOVE_WORK_LOG = 'WORK_LOGS/REMOVE_WORK_LOG';

// Initial state for reducer
const initialState = {
    isLoading: true,
    error: null,
    activeGroups: [],
    groups: [],
    allWorkLogs: [],
};

// Reducer(s)
export default function workLogReducer(state = initialState, action) {
    switch (action.type) {
        case SET_LOADING:
            return {...state, isLoading: true, error: null};
        case SET_ERROR:
            return {...state, isLoading: false, error: action.error};
        case SET_WORK_LOGS:
            return {
                ...state,
                groups: action.groups,
                activeGroups: action.activeGroups,
                allWorkLogs: action.allWorkLogs,
                isLoading: false,
            };
        case PREPEND_WORK_LOG:
            return {
                ...state,
                groups: [action.group, ...state.groups],
                activeGroups: [action.group, ...state.activeGroups],
                isLoading: false,
            };
        case UPDATE_WORK_LOG: {
            const group = action.group;
            const groups = state.groups.map(g => (g.id === group.id ? group : g));
            const activeGroups = state.activeGroups.map(
                g => (g.id === group.id ? group : g)).filter(g => g.end_time === null);
            return {...state, groups, activeGroups, isLoading: false};
        }
        case REMOVE_WORK_LOG: {
            const filteredWorkLogGroups = state.groups.filter(g => g.id !== action.groupId);
            const filteredActiveWorkLogGroups = state.activeGroups.filter(g => g.id !== action.groupId);
            return {
                ...state,
                groups: filteredWorkLogGroups,
                activeGroups: filteredActiveWorkLogGroups,
                isLoading: false,
            };
        }
        default:
            return state;
    }
}


const setError = error => ({type: SET_ERROR, error});
const setLoading = () => ({type: SET_LOADING});
const setWorkLogGroups = (groups, activeGroups) => {
    let allWorkLogs = [];
    groups.forEach(group => allWorkLogs.push(group.work_logs));
    allWorkLogs = [].concat(...allWorkLogs);
    return ({type: SET_WORK_LOGS, groups, activeGroups, allWorkLogs});
};
const prependWorkLogGroup = group => ({type: PREPEND_WORK_LOG, group});
const updateWorkLogGroup = group => ({type: UPDATE_WORK_LOG, group});
const removeWorkLogGroup = groupId => ({type: REMOVE_WORK_LOG, groupId});


export const fetchWorkLogs = (productId, userId) => (dispatch) => {
    dispatch(setLoading());
    api.productionWorkLogGroupList.fetch(null, {product: productId}).then(
        (groupsData) => {
            api.productionWorkLogGroupList.fetch(null, {active_for_user: userId}).then(
                activeGroupsData => dispatch(setWorkLogGroups(groupsData.results, activeGroupsData.results)),
                error => dispatch(setError(error.responseText)),
            );
        },
        error => dispatch(setError(error.responseText)),
    );
};

export const workLogStart = (productId, userId, fetchProductSpecific) => (dispatch) => {
    dispatch(setLoading());
    api.productionWorkLogGroupList.post(null, {product: productId}).then(
        (group) => {
            dispatch(prependWorkLogGroup(group));
            dispatch(fetchWorkLogs(fetchProductSpecific ? productId : null, userId));
        },
        error => dispatch(setError(error.responseText)),
    );
};

export const workLogAction = (groupId, action, productId, userId, fetchProductSpecific) => (dispatch) => {
    dispatch(setLoading());
    api.productionWorkLogGroupDetail.patch({pk: groupId}, {action}).then(
        (group) => {
            if (action === 'cancel') {
                dispatch(removeWorkLogGroup(groupId));
            } else {
                dispatch(updateWorkLogGroup(group));
            }
            if (action === 'stop') {
                dispatch(refreshProducts());
                dispatch(push(`/${USER_LANG}/production`));
            }
            dispatch(fetchWorkLogs(fetchProductSpecific ? productId : null, userId));
        },
        error => dispatch(setError(error.responseText)),
    );
};

export const workLogAddProduct = (groupId, productId, userId, fetchProductSpecific) => (dispatch) => {
    dispatch(setLoading());
    api.productionWorkLogGroupAddProduct.patch({pk: groupId}, {product: productId}).then(
        (group) => {
            dispatch(prependWorkLogGroup(group));
            dispatch(fetchWorkLogs(fetchProductSpecific ? productId : null, userId));
        },
        error => dispatch(setError(error.responseText)),
    );
};

export const workLogAddWorker = (groupId, userId) => (dispatch) => {
    dispatch(setLoading());
    api.productionWorkLogGroupAddWorker.patch({pk: groupId}, {user: userId}).then(
        group => dispatch(updateWorkLogGroup(group)),
        error => dispatch(setError(error.responseText)),
    );
};

/**
 * Stop one product in a work log group. This will stop the work log group and
 * start a group with the remaining products in it. For example, if we have a
 * work log group with [A, B, C] and we stop B, the work log group will be
 * stopped and a new group would be started containing only [A, C].
 */
export const workLogGroupStopOneProduct = (workLogGroupId, productId, userId) => (dispatch) => {
    api.productionWorkLogGroupStopOneProduct.post({pk: workLogGroupId}, {product: productId})
        .then(
            () => {
                dispatch(refreshProducts());
                dispatch(push(`/${USER_LANG}/production`));
                dispatch(fetchWorkLogs(null, userId));
            },
            err => console.error(err),
        );
};



// WEBPACK FOOTER //
// ./src/ducks/workLogs.js